export const COUNTRY_LIST_ATTEMPT = 'COUNTRY_LIST_ATTEMPT';
export const COUNTRY_LIST_SUCCESS = 'COUNTRY_LIST_SUCCESS';
export const COUNTRY_LIST_FAILED = 'COUNTRY_LIST_FAILED';

export const LOGOUT = "LOGOUT";

export const COUNTRY_UPDATE_SUCCESS = 'COUNTRY_UPDATE_SUCCESS';
export const COUNTRY_UPDATE_FAILED = 'COUNTRY_UPDATE_FAILED';

